<div style="overflow: hidden;">
    <div>
        <mat-dialog-actions>
            <Button mat-dialog-close mat-raised-button class="btn" style="margin-left: 80%;">
                Close
            </Button>
        </mat-dialog-actions>
    </div>
    <div>
        <h2 style="text-align: center;    margin-top: 5%;">Update Taluka Name</h2>
        <form [formGroup]="talukaForm" (ngSubmit)="updateTaluka()">
            <div class="form-row">
                <mat-form-field style="width: 80%; margin-top: 10%; margin-left: 10%" appearance="outline">
                    <mat-label>Taluka Name:</mat-label>
                    <input type="text" matInput formControlName="talukaname" required />
                </mat-form-field>
            </div>
            <div class="form-row">
                <mat-form-field style="width: 80%; margin-top: 10%; margin-left: 10%" appearance="outline">
                    <mat-label>Pincode :</mat-label>
                    <input type="text" matInput formControlName="talukapincode" required />
                </mat-form-field>
            </div>
            <div class="form-group">
                <button style="width: 60%;margin-left: 20%;margin-top: 5%;" [disabled]="talukaForm.invalid"
                    class="btn btn-info">Update</button>
            </div>
        </form>
    </div>
</div>